import React, {useEffect, useState} from "react";
import {getItems} from "../../../utils/communication";
import HFCheckbox from "../../../components/form/hf-checkbox";
import Modal from "../../../components/modal";
import {Link} from "react-router-dom";
import {NoteTag} from "../../../model/node";

export default function TagDashboardHome() {
    const [Tags, setTags] = useState<NoteTag[]>([]),
        [checked, setChecked] = useState<{ [index: number]: boolean }>({}),
        [selected, setSelected] = useState<number>(-1),
        [editingTagId, setEditingTagId] = useState<string | undefined>();

    useEffect(() => {
        document.title = "All Tags - Dashboard - Hoarfroster";

        fetchTags().then(() => {
        })
    }, []);

    const fetchTags = async () => {
        let response = await getItems<NoteTag>("/note/tag/all?columns=public_id,name,description,created_at,updated_at");

        if (response.code === 200) {
            setTags(response.data as NoteTag[]);
        } else {
            console.error(response);
        }
    }

    const handleCheckboxChange = (index: number) => {
        setChecked({...checked, [index]: !checked[index]});
    }

    return (<>
        <Modal title="Edit Tag" visible={editingTagId !== undefined} onClose={() => {
            setEditingTagId(undefined);
        }}>
            {/*{editingTagId && <TagEditContent id={editingTagId} onSubmitted={() => {*/}
            {/*    setEditingTagId(undefined);*/}
            {/*}}/>}*/}
        </Modal>
        <div className="dashboard-table">
            <div className="table-prefix">
                <p className="prefix">All Tags: {Tags.length}</p>

                <div>
                    <button onClick={fetchTags}>Reload</button>
                    <button onClick={() => setEditingTagId("new")}>New Tag</button>
                </div>
            </div>
            <div className="table-container">
                <div className="table-head">
                    <div className="w-16"/>
                    <div className="w-32">Public ID</div>
                    <div className="w-48">Name</div>
                    <div className="w-48">Description</div>
                    <div className="w-32">Created At</div>
                    <div className="w-32">Updated At</div>
                </div>
                <div className="table-body">
                    {Tags.map((Tag, index) => (
                        <div key={index} className="table-row"
                             onClick={() => setSelected(selected === index ? -1 : index)}>
                            <div className="row-content">
                                <div className="w-16">
                                    <HFCheckbox
                                        label=""
                                        name={Tag.publicId}
                                        checked={checked[index]}
                                        onChange={() => handleCheckboxChange(index)}/>
                                </div>
                                <div className="w-32 font-mono">{Tag.publicId}</div>
                                <div className="w-48">{Tag.name}</div>
                                <div className="w-48">{Tag.description}</div>
                                <div className="w-32">{Tag.createdAt.toString()}</div>
                                <div className="w-32">{Tag.updatedAt.toString()}</div>
                            </div>
                            <div className={"row-actions " + (selected == index ? "show" : "")}>
                                <button onClick={(event) => {
                                    event.stopPropagation();
                                    setEditingTagId(Tag.publicId);
                                }}>
                                    Edit Tag
                                </button>
                                <Link className="button" to={"/note/tag/" + Tag.publicId}>
                                    Read Tag
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </>);
}